<div class="container common-container-padding">
  <div class="page-title">GWP by class by month</div>

  <div>
    <div class="tooltip-and-chart">
      <!-- TOOLTIP -->

      <!-- Tooltip for mobile view-->
      <div
        class="stacked-tooltip-container mobile-stacked"
        [ngClass]="{
          'display-none': desktopScreen,
          'display-block': !desktopScreen,
        }"
      >
        <div class="stacked-tooltip2" id="stacked-tooltip2"></div>
      </div>

      <!-- Tooltip for desktop view-->
      <div
        class="stacked-tooltip-container"
        [ngStyle]="{ left: chartPad }"
        [ngClass]="{
          'display-none': !desktopScreen,
          'display-inline-flex': desktopScreen,
        }"
      >
        <div class="stacked-tooltip" id="stacked-tooltip"></div>
      </div>

      <div class="chart-and-legend" style="position: relative">
        <!-- CHART for mobile-->
        <div
          id="mobile-scroll-div"
          class="mobile-scroll"
          [ngClass]="{
            'display-none': desktopScreen,
            'display-block': !desktopScreen,
          }"
          [ngStyle]="{ width: setMobileScrollWidth() }"
        >
          <div
            class="stacked-chart-container"
            style="height: 300px"
            [ngStyle]="{ width: setMobileStackedWidth() }"
          >
            <canvas
              id="stackedChart2"
              class="chart-styles"
              height="300"
              width="600"
            >
            </canvas>
          </div>
          <canvas id="yAxisLabel" height="300" width="0"></canvas>
          <canvas id="yAxisMobile" height="300" width="0"></canvas>
          <span class="swiper-text lbl">Swipe to view more</span>
        </div>

        <!-- CHART for desktop-->
        <div
          class="stacked-chart-container"
          [ngClass]="{
            'display-none': !desktopScreen,
            'display-block': desktopScreen,
          }"
        >
          <canvas id="stackedChart" #stackedChartWindow class="chart-styles">
          </canvas>
        </div>

        <!-- LEGEND for mobile view -->
        <div
          class="stacked-legend-container"
          style="padding-bottom: 32px"
          [ngClass]="{
            'display-none': desktopScreen,
            'display-block': !desktopScreen,
          }"
        >
          <div id="stacked-legend2"></div>
        </div>

        <!-- LEGEND for desktop view -->
        <div
          class="stacked-legend-container"
          [ngClass]="{
            'display-none': !desktopScreen,
            'display-block': desktopScreen,
          }"
        >
          <div id="stacked-legend"></div>
        </div>
      </div>
    </div>
  </div>
</div>
